import { render, staticRenderFns } from "./ComponenteDialogoEdicion.vue?vue&type=template&id=30b83046&scoped=true&"
import script from "./ComponenteDialogoEdicion.vue?vue&type=script&lang=ts&"
export * from "./ComponenteDialogoEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteDialogoEdicion.vue?vue&type=style&index=0&id=30b83046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b83046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('30b83046', component.options)
    } else {
      api.reload('30b83046', component.options)
    }
    module.hot.accept("./ComponenteDialogoEdicion.vue?vue&type=template&id=30b83046&scoped=true&", function () {
      api.rerender('30b83046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SIMSolicitudes/ComponenteDialogoEdicion.vue"
export default component.exports